import { Flex, Typography } from 'antd';
import React from 'react';
import antdIconsMap from 'src/common/mapping/antdIconsMap';
import IconAsText from 'src/components/IconAsText';
import { IconArea } from 'src/pages/dashboard/components/cards/styles';

interface IRenderedAdder {
	rows?: string;
	field?: string;
	description?: string;
	icon?: keyof typeof antdIconsMap;
}

export default function RenderedAdder({ field, rows, description, icon, }:IRenderedAdder) {
	const sum = React.useMemo(() => {
		try{
			if(!rows || !field) return null;
			const _rows = JSON.parse(rows) as ({[key: string]: string | number })[];

			if(Object.keys(_rows?.at(0) ?? {}).includes(field )){
				return _rows.reduce((acc, row) => {
					const parsedValue = +row[field];
					return acc + (parsedValue ?? 0);
				}, 0);
			}
			return null;
		}catch(error){return null;}
        

	}, [ rows, field, ]);
	return (
		<Flex align='center' justify='space-between' style={{ width: '100%', height: '100%', padding: 12, gap: 5, flex: 1, }}>
			<Flex justify='center' style={{ height: '100%', }} vertical>
				<Typography.Text style={{
					fontWeight: 'bold',
					fontSize: 19,
				}}
				>{sum ?? 0}</Typography.Text>
				<Typography.Text type='secondary' style={{
					fontSize: 17,
					margin: 0,
				}}
				>{description}</Typography.Text>
			</Flex>
			<IconArea
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				{icon && (
					<IconAsText color={'white'} fontSize={22} icon={icon} />
				)}
			</IconArea>
		</Flex>
	);
}
